// extracted by mini-css-extract-plugin
export default {"AppWrapper":"Weather_AppWrapper__isSaS","AppMain":"Weather_AppMain__pm7ne"};